import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import FileUpload from "@/components/FileUpload";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

const BLANK = { title: "", video_url: "", duration: "", notes: "", resource_url: "", is_preview: false };

export function LessonDialog({ open, onOpenChange, sectionId, lesson, onSaved }) {
  const [f, setF] = useState(BLANK);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (open) { setF(lesson ? { ...BLANK, ...lesson } : BLANK); }
  }, [open, lesson]);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const save = async () => {
    if (!f.title.trim()) return toast.error("Enter a lesson title");
    setSaving(true);
    const body = { title: f.title, video_url: f.video_url, duration: f.duration, notes: f.notes, resource_url: f.resource_url, is_preview: f.is_preview, content_type: "video" };
    try {
      if (lesson) await api.put(`/lessons/${lesson.id}`, body);
      else await api.post(`/sections/${sectionId}/lessons`, body);
      toast.success(lesson ? "Lesson updated" : "Lesson added");
      onOpenChange(false); onSaved();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-auto">
        <DialogHeader><DialogTitle>{lesson ? "Edit Lesson" : "Add Lesson"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Title *</Label><Input value={f.title} onChange={(e) => set("title", e.target.value)} data-testid="lesson-title" /></div>
          <div className="rounded-lg border border-border p-3 space-y-2">
            <Label>Lecture Video</Label>
            <FileUpload accept="video/*" value={f.video_url?.includes("/api/files/") ? f.video_url : ""} onChange={(url) => set("video_url", url)} testid="video-upload" />
            <p className="text-xs text-muted-foreground">or paste an embed / stream URL</p>
            <Input value={f.video_url || ""} onChange={(e) => set("video_url", e.target.value)} placeholder="https://youtube.com/embed/..." data-testid="video-url" />
          </div>
          <div><Label>Duration</Label><Input value={f.duration || ""} onChange={(e) => set("duration", e.target.value)} placeholder="e.g. 12:30" data-testid="lesson-duration" /></div>
          <div><Label>Notes (text)</Label><Textarea value={f.notes || ""} onChange={(e) => set("notes", e.target.value)} data-testid="lesson-notes" /></div>
          <div className="rounded-lg border border-border p-3 space-y-2">
            <Label>Attach Notes / PDF</Label>
            <FileUpload accept=".pdf,.doc,.docx,image/*" value={f.resource_url || ""} onChange={(url) => set("resource_url", url)} testid="resource-upload" />
          </div>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!f.is_preview} onChange={(e) => set("is_preview", e.target.checked)} data-testid="lesson-preview" /> Free preview</label>
        </div>
        <DialogFooter><Button className="viriks-navy text-white" disabled={saving} onClick={save} data-testid="save-lesson">{saving ? "Saving..." : lesson ? "Save Changes" : "Add Lesson"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
